import { render, staticRenderFns } from "./DevPage.vue?vue&type=template&id=126d9a43&scoped=true&"
import script from "./DevPage.vue?vue&type=script&lang=js&"
export * from "./DevPage.vue?vue&type=script&lang=js&"
import style0 from "./DevPage.vue?vue&type=style&index=0&id=126d9a43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d9a43",
  null
  
)

export default component.exports